import { Link } from 'react-router-dom';
import './AdminBackLink.css';

/** Regreso al panel global del administrador desde cualquier módulo. */
export default function AdminBackLink({ label = 'Volver al panel global' }) {
    return (
        <p className="admin-back-wrap">
            <Link to="/" className="admin-back-link">
                ← {label}
            </Link>
        </p>
    );
}
